import { render, staticRenderFns } from "./TableWrapperHeader.vue?vue&type=template&id=04c860ee&scoped=true&"
import script from "./TableWrapperHeader.vue?vue&type=script&lang=js&"
export * from "./TableWrapperHeader.vue?vue&type=script&lang=js&"
import style0 from "./TableWrapperHeader.vue?vue&type=style&index=0&id=04c860ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c860ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
